import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";

import ListNode from "./listNode";
import styles from "./tilePanel.module.css";

function getNodeKey(node, index) {
	if (!node) {
		return `node-${index}`;
	}

	const pathKey = Array.isArray(node.path) ? node.path.join("/") : node.path;
	return node.guid || node.id || node.fullPath || pathKey || node.name || `node-${index}`;
}

class ListPanel extends PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	renderItems(items) {
		const { onSelect, onDblClick, accept } = this.props;
		return items.map((item, index) => (
			<ListNode key={getNodeKey(item, index)} node={item} onSelect={onSelect} onDblClick={onDblClick} accept={accept} />
		));
	}

	render() {
		const { data } = this.props;

		let children = data ?? [];
		if (children.length === 0) {
			return <div className="message-container">{"No items to view"}</div>;
		}

		const isSearchResultList = children.some(item => item && item.searchResult);
		if (!isSearchResultList) {
			return <div>{this.renderItems(children)}</div>;
		}

		const folders = [];
		const files = [];
		const otherItems = [];

		children.forEach(item => {
			if (item?.type === "folder") {
				folders.push(item);
			} else if (item?.type === "file") {
				files.push(item);
			} else {
				otherItems.push(item);
			}
		});

		return (
			<div>
				{folders.length > 0 ? (
					<div>
						<div className={styles["item-group-header"]}>Folders</div>
						{this.renderItems(folders)}
					</div>
				) : null}
				{files.length > 0 ? (
					<div>
						<div className={styles["item-group-header"]}>Files</div>
						{this.renderItems(files)}
					</div>
				) : null}
				{otherItems.length > 0 ? this.renderItems(otherItems) : null}
			</div>
		);
	}
}

export default branch({}, ListPanel);
